{
  "name": "frontend",
  "version": "1.33.0",
  "engines": {
    "node": ">=18.19.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test",
    "stats": "ng build --stats-json && webpack-bundle-analyzer dist/listing/stats.json -s gzip",
    "start-proxy": "ng serve --proxy-config proxy.conf.json --configuration=local",
    "start-docker": "ng serve --proxy-config proxy.docker.conf.json --configuration=docker"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.2.20",
    "@angular/cdk": "^19.2.19",
    "@angular/common": "^19.2.20",
    "@angular/compiler": "^19.2.20",
    "@angular/core": "^19.2.20",
    "@angular/forms": "^19.2.20",
    "@angular/google-maps": "^18.2.14",
    "@angular/material": "^19.2.19",
    "@angular/platform-browser": "^19.2.20",
    "@angular/platform-browser-dynamic": "^19.2.20",
    "@angular/router": "^19.2.20",
    "@auth0/angular-jwt": "^5.0.2",
    "@ngneat/until-destroy": "^10.0.0",
    "compressorjs": "^1.2.1",
    "crypto-js": "^4.2.0",
    "damerau-levenshtein": "^1.0.8",
    "heic-to": "^1.3.0",
    "jaro-winkler": "^0.2.8",
    "lodash.startcase": "^4.4.0",
    "ngx-image-cropper": "^6.3.2",
    "pdfmake": "^0.2.5",
    "rxjs": "^7.8.2",
    "tinycolor2": "^1.4.2",
    "tslib": "^2.4.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular-builders/custom-esbuild": "^19.1.0",
    "@angular/build": "^19.2.22",
    "@angular/cli": "^19.2.22",
    "@angular/compiler-cli": "^19.2.20",
    "@types/jasmine": "~3.8.0",
    "git-revision-webpack-plugin": "^5.0.0",
    "jasmine-core": "~3.8.0",
    "karma": "^6.3.20",
    "karma-chrome-launcher": "~3.1.0",
    "karma-coverage": "~2.0.3",
    "karma-jasmine": "^4.0.2",
    "karma-jasmine-html-reporter": "~1.7.0",
    "typescript": "~5.8.3",
    "webpack-bundle-analyzer": "^4.5.0"
  }
}
